'/create-folder/:parentId';

import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export const postDuplicateItems = async (
  { filePermissionIds, targetProjectId, projectIds, targetParentFilePermissionId },
  projectId
) => {
  const apiPath = `project-bank/${projectId}/duplicate-items`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ filePermissionIds, targetProjectId, projectIds, targetParentFilePermissionId }), // aws4 looks for body; axios for data
    data: { filePermissionIds, targetProjectId, projectIds, targetParentFilePermissionId },
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
